module.exports = __webpack_public_path__ + "img/apple-pay.9a50e9af.svg";